export const SHORT_DATE = 'MMMM dd, yyyy';
export const LONG_DATE_DATE = 'MMMM dd, yyyy';
export const LONG_DATE_TIME = 'hh:mm:ss aaa';
export const LONG_DATE = `${LONG_DATE_DATE} ${LONG_DATE_TIME}`;
export const COMPACT_DATE_DATE = 'MMM dd, yyyy';
export const COMPACT_DATE_TIME = 'hh:mm:ss aaa';
export const COMPACT_DATE = `${COMPACT_DATE_DATE} ${COMPACT_DATE_TIME}`;
export const COMPACT_LONG_DATE = COMPACT_DATE;
export const COMPACT_SHORT_DATE = COMPACT_DATE_DATE;
export const COMPACT_DATE_V2 = `${COMPACT_DATE_DATE} HH:mm`;

export const application = {};

application.DATE = 'dd/MM/yyyy';
application.TIME = 'hh:mm a';
application.DATE_TIME = `${application.DATE} ${application.TIME}`;

export const browser = {};

browser.DATE = 'yyyy-MM-dd';
browser.TIME = 'HH:mm';
browser.DATE_TIME = `${browser.DATE} ${browser.TIME}`;

export const server = {};

server.DATE = 'dd/MM/yyyy';
server.TIME = 'hh:mm A';
server.DATE_TIME = `${server.DATE} ${server.TIME}`;